<template>
  <div
    class="manager_box"
    style="background: white; min-height: 80vh; padding: 20px"
    v-loading="loading"
  >
    <div class="export_staff_div">
      <div class="screen_div">
        <el-button
          style="margin-right: 20px"
          size="medium"
          @click="add_screening_criteria"
          >添加筛选条件</el-button
        >
        <el-button style="width: 120px" @click="add_employee"
          >添加员工</el-button
        >
      </div>
      <el-button type="primary" @click="export_staff">导出员工</el-button>
    </div>
    <div
      style="
        min-height: 30px;
        background: white;
        margin-bottom: 20px;
        padding-top: 20px;
        padding-left: 20px;
      "
    >
      <!-- <span v-if='not_empty.length > 0'> 筛选条件： </span> -->
      <el-breadcrumb separator="/">
        <el-breadcrumb-item v-for="item in not_empty" :key="item.label">
          <span style="color: #aaa">{{ item.name }}</span>
          {{ item.item }}
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="在职" name="0"></el-tab-pane>
      <el-tab-pane label="离职" name="1"></el-tab-pane>
    </el-tabs>
    <el-table
      :data="tableData"
      style="width: 100%"
      ref="multipleTable"
      @selection-change="handleSelectionChange"
      @row-click="tableData_row_click"
      :row-class-name="tableRowClassName"
    >
      <el-table-column type="selection" width="50"></el-table-column>
      <el-table-column
        prop="name"
        label="姓名"
        min-width="60"
      ></el-table-column>
      <el-table-column
        prop="gender_name"
        label="性别"
        min-width="60"
      ></el-table-column>
      <el-table-column prop="age" label="年龄" min-width="60"></el-table-column>
      <el-table-column
        prop="ed_name"
        label="员工所属"
        min-width="100"
      ></el-table-column>
      <!-- <el-table-column prop="position" label="所属职位" min-width="100"> </el-table-column> -->
      <el-table-column
        prop="is_leave"
        label="是否在职"
        min-width="100"
      ></el-table-column>
      <el-table-column
        prop="social_security"
        label="是否入社保"
        min-width="100"
      ></el-table-column>
      <el-table-column
        prop="present_address"
        label="当前地址"
        min-width="100"
      ></el-table-column>
      <el-table-column
        prop="mobile"
        label="手机号"
        min-width="120"
      ></el-table-column>
      <el-table-column
        prop="id_card"
        label="身份证号"
        min-width="180"
      ></el-table-column>
      <el-table-column
        prop="join_time"
        label="入职时间"
        min-width="180"
      ></el-table-column>
      <el-table-column label="操作" min-width="180" fixed="right">
        <template slot-scope="scope">
          <el-button
            @click.stop="modify_tableData(scope.row.staff_id)"
            type="primary"
            >修改</el-button
          >
          <el-button
            @click.stop="delete_tableData(scope.row.staff_id)"
            type="danger"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="page">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="staff_count"
        :current-page="currentPage"
        @current-change="currentChange"
        hide-on-single-page
      ></el-pagination>
    </div>

    <el-drawer
      title="详情"
      :visible.sync="drawer"
      :with-header="false"
      size="800px"
    >
      <div class="el_drawer">
        <div class="interval">
          <span class="span">基本信息</span>
          <div class="basic_information_content">
            <div
              class="for_name_value"
              v-for="item in stand_in_data_staff_data"
              :key="item.name"
            >
              {{ item.name }}：{{ item.value }}
            </div>
          </div>
        </div>
        <div v-if="data_education_data.length > 0" class="interval">
          <span class="span">教育经历</span>
          <div
            v-for="(item, index) in data_education_data"
            :key="item.school_name"
          >
            <div v-if="index != 0" class="Line"></div>
            <div class="basic_information_content">
              <div class="for_name_value">学校：{{ item.school_name }}</div>
              <div class="for_name_value">
                学历：{{ item.education_background }}
              </div>
              <div class="for_name_value">专业：{{ item.specialty }}</div>
              <div class="for_name_value">
                毕业时间：
                <span v-if="item.ed_start_time != 0"
                  >{{ item.ed_start_time_str }} -
                  {{ item.ed_end_time_str }}</span
                >
              </div>
            </div>
          </div>
        </div>
        <div v-if="data_work_experience.length > 0" class="interval">
          <span class="span">工作经历</span>
          <div
            v-for="(item, index) in data_work_experience"
            :key="item.company_name"
          >
            <div v-if="index != 0" class="Line"></div>
            <div class="basic_information_content">
              <div class="for_name_value">公司：{{ item.company_name }}</div>
              <div class="for_name_value">部门：{{ item.department_name }}</div>
              <div class="for_name_value">薪资：{{ item.salary }}</div>
              <div class="for_name_value">
                工作时间：
                <span v-if="item.work_start_time != 0"
                  >{{ item.work_start_time_str }} -
                  {{ item.work_end_time_str }}</span
                >
              </div>
            </div>
          </div>
        </div>
        <div v-if="data_family_data.length > 0" class="interval">
          <span class="span">家庭信息</span>
          <div
            v-for="(item, index) in data_family_data"
            :key="item.family_name"
          >
            <div v-if="index != 0" class="Line"></div>
            <div class="basic_information_content">
              <div class="for_name_value">名字：{{ item.family_name }}</div>
              <div class="for_name_value">关系：{{ item.family_relation }}</div>
              <div class="for_name_value">手机号：{{ item.family_phone }}</div>
              <div class="for_name_value">
                职业：{{ item.family_profession }}
              </div>
            </div>
          </div>
        </div>
        <div class="operation_tableData">
          <el-button
            style="width: 100px"
            @click.stop="modify_tableData()"
            type="primary"
            >修改</el-button
          >
          <el-button
            style="width: 100px"
            @click.stop="delete_tableData()"
            type="danger"
            >删除</el-button
          >
        </div>
      </div>
    </el-drawer>

    <el-dialog
      title="筛选"
      :visible.sync="outerVisible"
      style="min-width: 900px"
    >
      <el-form label-width="120px">
        <el-form-item label="姓名">
          <el-input
            v-model="outerVisible_name_list_name"
            placeholder="筛选的姓名"
            class="el_input"
          ></el-input>
        </el-form-item>
        <el-form-item label="入职开始时间">
          <el-date-picker
            v-model="outerVisible_name_list.start_time"
            type="date"
            placeholder="选择日期"
            value-format="timestamp"
            class="el_input"
            @change="start_selecting_time"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="入职结束时间">
          <el-date-picker
            v-model="outerVisible_name_list.end_time"
            type="date"
            placeholder="选择日期"
            value-format="timestamp"
            class="el_input"
            @change="end_selection_time"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="是否已入社保">
          <el-select
            v-model="outerVisible_name_list.is_social_security"
            clearable
            placeholder="是否已入社保"
            class="el_input"
            @clear="delete_filter(3)"
            @change="check_filter"
          >
            <el-option
              v-for="item in is_social_security_options"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属">
          <!-- <el-select v-model="outerVisible_name_list.ed_id" clearable placeholder="部门" class='el_input' @clear='delete_filter(4)' @change='check_filter1'>
                        <el-option v-for="item in options" :key="item.ed_id" :label="item.ed_name" :value="item.ed_id"></el-option>
          </el-select>-->
          <el-cascader
            v-model="cascader_ed_id"
            :options="options"
            :props="{ checkStrictly: true, label: 'ed_name', value: 'ed_id' }"
            clearable
            class="el_input"
            separator=" - "
            @change="cascader_checkStrictly"
            ref="cascader"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="员工状态">
          <el-select
            v-model="outerVisible_name_list.staff_status"
            value-format="timestamp"
            clearable
            placeholder="员工状态"
            class="el_input"
            @clear="delete_filter(5)"
            @change="check_filter2"
          >
            <el-option
              v-for="item in user_status_options"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.stop="stand_in()">取消</el-button>
        <el-button @click.stop="criteria_tableData()" type="primary"
          >确定筛选</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { require } from "@/utils/http_request.js";
export default {
  data() {
    return {
      loading: true,
      drawer: false,
      outerVisible: false,
      tableData: [],
      tableData_li: [],
      multipleSelection: [],
      staff_count: 0,
      currentPage: 1,
      data_staff_data: [],
      data_education_data: [],
      data_work_experience: [],
      data_family_data: [],
      row_staff_id: "",
      cascader_ed_id: [],

      outerVisible_name: [
        {
          name: "姓名：",
          label: "name",
          value: "",
          item: "",
        },
        {
          name: "入职开始时间：",
          label: "start_time",
          value: "",
          item: "",
        },
        {
          name: "入职结束时间：",
          label: "end_time",
          value: "",
          item: "",
        },
        {
          name: "是否已入社保：",
          label: "is_social_security",
          value: "",
          item: "",
        },
        {
          name: "部门：",
          label: "ed_id",
          value: "",
          item: "",
        },
        {
          name: "员工状态：",
          label: "staff_status",
          value: "",
          item: "",
        },
      ],
      stand_in_outerVisible_name: [
        {
          name: "姓名：",
          label: "name",
          value: "",
          item: "",
        },
        {
          name: "入职开始时间：",
          label: "start_time",
          value: "",
          item: "",
        },
        {
          name: "入职结束时间：",
          label: "end_time",
          value: "",
          item: "",
        },
        {
          name: "是否已入社保：",
          label: "is_social_security",
          value: "",
          item: "",
        },
        {
          name: "部门：",
          label: "ed_id",
          value: "",
          item: "",
        },
        {
          name: "员工状态：",
          label: "staff_status",
          value: "",
          item: "",
        },
      ],

      outerVisible_name_list_name: "",
      outerVisible_name_list: {
        start_time: "",
        end_time: "",
        is_social_security: "",
        ed_id: "",
        staff_status: "",
      },
      is_social_security_options: [
        { name: "是", value: "1" },
        { name: "否", value: "2" },
      ],
      user_status_options: [
        { name: "试用", value: "1" },
        { name: "正式", value: "2" },
      ],
      options: [],
      activeName: "0",
      page: 0,
    };
  },
  created() {
    this.staff_list();
    this.department_list();
  },
  methods: {
    //分页
    currentChange(page) {
      this.page = page - 1;
      this.currentPage = page;
      if (this.not_empty.length > 0) {
        this.criteria_tableData(this.page);
      } else {
        this.staff_list(this.activeName, this.page);
      }
    },
    //标签切换
    handleClick() {
      this.currentPage = 1;
      this.page = 0;
      if (this.not_empty.length > 0) {
        this.criteria_tableData(this.page);
      } else {
        this.staff_list(this.activeName, this.page);
      }
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.is_leave == "已离职") {
        return "warning-row";
      }
      return "";
    },
    department_list() {
      // 部门
      require("post", "/lufish_hrm/v1/department_list/", {}).then((res) => {
        if (!res.code) {
          this.options = res.data;
        }
      });
    },

    staff_list(is_leave_staff = 0, page = 0) {
      this.loading = true;
      //   is_leave_staff=0  在职列表   =1离职表
      require("post", "/lufish_hrm/v1/staff_list/", {
        is_leave_staff: is_leave_staff,
        page,
      }).then((res) => {
        console.log("员工列表", res);
        if (!res.code) {
          this.tableData = res.data;
          this.staff_count = res.staff_count;
        }
        this.loading = false;
      });
    },
    export_staff() {
      // 导出员工
      if (this.multipleSelection.length == 0) {
        this.$message.error("请选择添加的员工");
        return false;
      }
      require("post", "/lufish_hrm/v1/staff_excel/", {
        staff_id_list: this.multipleSelection,
      }).then((res) => {
        this.$message({
          message: "导出成功",
          type: "success",
        });
        console.log(res);
        if (!res.code) {
          try {
            var elemIF = document.createElement("iframe");
            elemIF.src = res.data;
            elemIF.style.display = "none";
            document.body.appendChild(elemIF);
          } catch (e) {
            alert("下载异常！");
          }
        }
      });
      console.log("导出员工", this.multipleSelection);
    },
    handleSelectionChange(val) {
      let add = [];
      val.forEach((item) => {
        add.push(item.staff_id);
      });
      this.multipleSelection = add;
    },
    tableData_row_click(row) {
      this.row_staff_id = row.staff_id;
      require("post", "/lufish_hrm/v1/staff_detail/", {
        staff_id: row.staff_id,
      }).then((res) => {
        console.log("详情", res);
        if (!res.code) {
          this.data_staff_data_click(res.data[0].staff_data[0]);
          this.data_education_data_click(res.data[0].education_data);
          this.data_work_experience_data_click(
            res.data[0].work_experience_data
          );
          this.data_family_data_click(res.data[0].family_data);
          this.drawer = true;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    data_staff_data_click(res) {
      // 基本信息
      this.data_staff_data = [
        { name: "姓名", value: res.name },
        { name: "手机号", value: res.mobile },
        { name: "年龄", value: res.age },
        { name: "性别", value: res.gender_name },
        // { name: '职位', value: res.position },
        { name: "部门", value: res.ed_name },
        { name: "身份证号", value: res.id_card },
        { name: "是否婚配", value: res.is_marry },
        { name: "支行", value: res.bank_branch },
        { name: "银行卡号", value: res.credit_card_num },
        { name: "工作性质", value: res.job_type_name },
        { name: "人员类型", value: res.staff_status_name },
        { name: "员工状态", value: res.user_status_name },
        { name: "是否已入社保", value: res.social_security },
        { name: "户籍所在地", value: res.domicile_place },
        { name: "现住址", value: res.present_address },
        { name: "民族", value: res.nation },
        { name: "邮箱", value: res.email },
        { name: "政治面貌", value: res.political },
        { name: "员工号", value: res.job_num },
        { name: "学历", value: res.education_background },
        { name: "专业", value: res.specialty },
        { name: "技能", value: res.skill },
        { name: "身体状况", value: res.physical_condition },
        { name: "爱好", value: res.hobby },
        { name: "出生年月", value: res.birth_year + "-" + res.birth_month },
        { name: "入职时间", value: res.join_time },
        { name: "转正时间", value: res.done_time },
        { name: "离职时间", value: res.leave_time },
      ];
      // console.log('基础信息', this.data_staff_data)
    },
    data_education_data_click(res) {
      // 教育背景
      console.log("内容", res);
      this.data_education_data = res;
    },
    data_work_experience_data_click(res) {
      // 教育背景
      console.log("内容", res);
      this.data_work_experience = res;
    },
    data_family_data_click(res) {
      // 教育背景
      console.log("内容", res);
      this.data_family_data = res;
    },
    modify_tableData(e) {
      console.log("修改的内容", e, this.row_staff_id);
      let staff_id = e;
      if (!e) {
        staff_id = this.row_staff_id;
      }
      this.$router.push({
        name: "add_employee",
        params: { staff_id: staff_id },
      });
    },
    delete_tableData(e) {
      // 删除员工
      let staff_id = e;
      if (!e) {
        staff_id = this.row_staff_id;
      }
      this.$confirm("确定删除此员工吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          console.log(e);
          require("post", "/lufish_hrm/v1/add_update_staff/", {
            label_code: "deleted",
            staff_id,
          }).then((res) => {
            this.$message({ message: res.msg, type: "success" });
            this.drawer = false;
            this.staff_list();
          });
        })
        .catch(() => {});
    },
    add_screening_criteria() {
      // 添加筛选条件
      let string_array = JSON.stringify(this.stand_in_outerVisible_name);
      this.outerVisible_name = JSON.parse(string_array);
      this.outerVisible_name.forEach((item) => {
        if (item.label != "name") {
          if (
            (item.label == "start_time" || item.label == "end_time") &&
            item.value != ""
          ) {
            console.log("11", item);
            this.outerVisible_name_list[item.label] = item.value * 1000;
          } else {
            console.log("22", item);
            this.outerVisible_name_list[item.label] = item.value;
          }
        } else {
          this.outerVisible_name_list_name = item.value;
        }
      });
      console.log("添加筛选条件", this.outerVisible_name);
      this.outerVisible = true;
    },
    add_employee() {
      // 添加
      this.$router.push({ name: "add_employee" });
    },
    getzf(num) {
      if (parseInt(num) < 10) {
        num = "0" + num;
      }
      return num;
    },
    start_selecting_time(e) {
      // 开始入职
      let oTime = "";
      let oDate = new Date(e);
      let oYear = oDate.getFullYear();
      let oMonth = oDate.getMonth() + 1;
      let oDay = oDate.getDate();
      oTime = oYear + "-" + this.getzf(oMonth) + "-" + this.getzf(oDay); //最后拼接时间
      this.outerVisible_name[1].value = e / 1000;
      this.outerVisible_name[1].item = oTime;
    },
    end_selection_time(e) {
      // 结束入职
      let oTime = "";
      let oDate = new Date(e);
      let oYear = oDate.getFullYear();
      let oMonth = oDate.getMonth() + 1;
      let oDay = oDate.getDate();
      oTime = oYear + "-" + this.getzf(oMonth) + "-" + this.getzf(oDay); //最后拼接时间
      this.outerVisible_name[2].value = e / 1000;
      this.outerVisible_name[2].item = oTime;
    },
    check_filter(e) {
      // 社保
      this.is_social_security_options.forEach((item) => {
        if (item.value == e) {
          this.outerVisible_name[3].value = item.value;
          this.outerVisible_name[3].item = item.name;
          console.log("社保", item);
        }
      });
    },
    check_filter1(e) {
      // 部门
      this.options.forEach((item) => {
        if (item.ed_id == e) {
          this.outerVisible_name[4].value = item.ed_id;
          this.outerVisible_name[4].item = item.ed_name;
          console.log("部门", item);
        }
      });
    },
    check_filter2(e) {
      // 员工状态
      this.user_status_options.forEach((item) => {
        if (item.value == e) {
          this.outerVisible_name[5].value = item.value;
          this.outerVisible_name[5].item = item.name;
          console.log("员工状态", item);
        }
      });
      console.log(e);
    },
    delete_filter(e) {
      console.log(e);
      this.outerVisible_name[e].value = "";
    },
    cascader_checkStrictly(e) {
      console.log(e);
      if (e.length != 0) {
        this.outerVisible_name_list.ed_id = e[e.length - 1];
        this.outerVisible_name[4].value = e[e.length - 1];
        this.outerVisible_name[4].item = this.$refs["cascader"]
          .getCheckedNodes()[0]
          .pathLabels.join(" - ");
      } else {
        this.outerVisible_name_list.ed_id = "";
        this.outerVisible_name[4].value = "";
        this.outerVisible_name[4].item = "";
      }
    },
    criteria_tableData(page = 0) {
      let obj = {};
      this.outerVisible_name.forEach((item) => {
        if (item.value != "") {
          console.log(item);
          obj[item.label] = item.value;
        }
      });
      this.loading = true;
      require("post", "/lufish_hrm/v1/staff_list/", {
        is_leave_staff: this.activeName,
        page,
        search_data: obj,
      }).then((res) => {
        console.log("员工列表", res);
        if (!res.code) {
          this.tableData = res.data;
          this.staff_count = res.staff_count;
          let string_array = JSON.stringify(this.outerVisible_name);
          this.stand_in_outerVisible_name = JSON.parse(string_array);
          console.log("替身", this.stand_in_outerVisible_name);
        } else {
          this.$message.error(res.msg);
        }
        this.loading = false;
        this.outerVisible = false;
      });
      console.log("传参", obj);
    },
    stand_in() {
      let string_array = JSON.stringify(this.stand_in_outerVisible_name);
      this.outerVisible_name = JSON.parse(string_array);
      console.log("替身", this.outerVisible_name);
      this.outerVisible = false;
    },
  },
  watch: {
    outerVisible_name_list_name: function (newvalue, oldvalue) {
      // console.log('参数', newvalue, oldvalue)
      this.outerVisible_name[0].value = newvalue;
      this.outerVisible_name[0].item = newvalue;
    },
  },
  computed: {
    stand_in_data_staff_data() {
      let add = [];
      this.data_staff_data.forEach((item) => {
        if (item.value != "") {
          if (item.name != "离职时间" && item.value != 0) {
            add.push(item);
          }
        }
      });
      // console.log('测试', add)
      return add;
    },
    not_empty() {
      let add = [];
      this.outerVisible_name.forEach((item) => {
        if (item.value != "") {
          add.push(item);
        }
      });
      return add;
    },
  },
};
</script>

<style>
.export_staff_div {
  display: flex;
  border-bottom: 1px #ccc solid;
  justify-content: space-between;
  padding: 12px 20px;
}
.el_drawer {
  position: relative;
  overflow: auto;
  height: 100vh;
  padding: 20px;
}
.el_drawer .span {
  font-size: 19px;
}
.basic_information_content {
  padding: 20px 0;
  display: flex;
  flex-wrap: wrap;
}
.for_name_value {
  width: 340px;
  padding: 10px;
  display: flex;
  flex-wrap: wrap;
}
.operation_tableData {
  border-top: 1px #ccc solid;
  background: white;
  width: 760px;
  box-sizing: border-box;
  position: fixed;
  bottom: 0px;
  right: 30px;
  padding: 10px 20px;
  display: flex;
  justify-content: flex-end;
}
.Line {
  border: 1px #ccc solid;
  border-radius: 50%;
  margin: 0 100px;
}
.interval {
  margin: 20px 0;
}
.el-table .warning-row {
  background: #ffe4e1;
}

.el_input {
  width: 80%;
}
.screen_div {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  line-height: 40px;
}
.page {
  padding: 12px 0;
  text-align: center;
}
</style>
le>



// WEBPACK FOOTER //
// src/personnel_matters/staff_management.vue